"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Status = void 0;
var Status;
(function (Status) {
    Status[Status["Uploading"] = 1] = "Uploading";
    Status[Status["Cancelled"] = 2] = "Cancelled";
    Status[Status["UploadFailed"] = 3] = "UploadFailed";
    Status[Status["UploadSuccessful"] = 4] = "UploadSuccessful";
    Status[Status["Transferring"] = 5] = "Transferring";
    Status[Status["TransferFailed"] = 6] = "TransferFailed";
    Status[Status["TransferSuccessful"] = 7] = "TransferSuccessful";
    Status[Status["Deleted"] = 8] = "Deleted";
    Status[Status["FileScanIncomplete"] = 9] = "FileScanIncomplete";
    Status[Status["FileScanSuccessful"] = 10] = "FileScanSuccessful";
    Status[Status["FileScanFailed"] = 11] = "FileScanFailed";
    Status[Status["TransferringToSA"] = 12] = "TransferringToSA";
    Status[Status["MessagingToQueue"] = 13] = "MessagingToQueue";
})(Status = exports.Status || (exports.Status = {}));
